
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { AdminApi } from '@/wwapi/apis/admin-api'
import { UserModel } from '@/wwapi/models'

@Component({
  name: 'UserSearch'
})
export default class extends Vue {
  @Prop({ default: 'Search by name, email or phone...' }) placeholder!: string
  @Prop({ default: '' }) value!: string
  @Prop({ default: true }) clearable!: boolean
  @Prop({ default: true }) showSelectedInfo!: boolean

  private users: UserModel[] = []
  private loading = false
  private selectedUserId = ''
  private selectedUser: UserModel | null = null

  @Watch('value', { immediate: true })
  onValueChange(val: string) {
    this.selectedUserId = val
    if (val && !this.selectedUser) {
      this.loadUserById(val)
    }
  }

  private async loadUserById(userId: string) {
    try {
      const adminApi = new AdminApi()
      const response = await adminApi.userListPost({
        text: userId
      } as any)
      const users = response.data?.data || []
      if (users.length > 0 && users[0].userId === userId) {
        this.selectedUser = users[0]
      }
    } catch (error) {
      console.error('Error loading user:', error)
    }
  }

  private async searchUsers(query: string) {
    if (!query || query.length < 2) {
      this.users = []
      return
    }

    this.loading = true
    try {
      const adminApi = new AdminApi()
      const response = await adminApi.userListPost({
        text: query,
        limit: 20
      } as any)
      this.users = response.data?.data || []
    } catch (error) {
      console.error('Error searching users:', error)
      this.users = []
    } finally {
      this.loading = false
    }
  }

  private formatUserLabel(user: UserModel): string {
    const name = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Unknown'
    const email = user.email || ''
    return email ? `${name} (${email})` : name
  }

  private handleSelect(userId: string) {
    const user = this.users.find(u => u.userId === userId)
    this.selectedUser = user || null
    this.$emit('input', userId)
    this.$emit('change', userId, user)
  }

  private handleClear() {
    this.selectedUser = null
    this.users = []
    this.$emit('input', '')
    this.$emit('change', '', null)
  }
}
